export default {
  fi: {
    ServiceEventCompleteReminderScene: {
      addServiceEvent: 'Lisää huoltotapahtuma',
    },
  },
};
